import React from 'react';
import { FiInfo, FiAlertTriangle, FiCheckCircle } from 'react-icons/fi';
import './AlertModal.css';

const AlertModal = ({ isOpen, type = 'info', title, message, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="alert-modal-overlay">
      <div className="alert-modal-box">
        <div className={`alert-modal-icon alert-modal-icon--${type}`}>
          {type === 'info' && <FiInfo />}
          {type === 'confirm' && <FiAlertTriangle />}
          {type === 'success' && <FiCheckCircle />}
        </div>
        <div className="alert-modal-content">
          <h3 className="alert-modal-title">{title}</h3>
          <p className="alert-modal-message">{message}</p>
        </div>
        <div className="alert-modal-actions">
          {type === 'confirm' && (
            <button className="alert-btn alert-btn--ghost" onClick={onCancel}>Cancel</button>
          )}
          <button className="alert-btn alert-btn--primary" onClick={onConfirm}>OK</button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
